import * as React from 'react';
import BlockProps from './BlockProps';
import Block from './Block';
import useNode from '~src/hooks/useNode';
import useDownload from '~src/hooks/useDownload';
import { getHandleBlockEvent } from '~src/hooks/useBlockEventListener';
import addCss from '~src/helpers/addCss';

addCss('BlockVideo', `
.b--video { }
.b__video-player { margin: 0; width: 100%; height: 100%; background-repeat: no-repeat; background-size: contain; background-position: center; }`);

export default function BlockVideo(props: BlockProps) {
	const data = useNode(props.itemId);

	const isWebm = !!data.webmUrl;
	const videoFile = useDownload(isWebm ? data.webmUrl : data.mp4Url);
	const coverFile = useDownload(data.coverUrl);

	const otherFile = useDownload((data.webmUrl || data.mp4Url) ? '' : data.url);
	
	return (
		<Block {...props}>
			<video
				key={data.id}
				className="b__video-player"
				style={{
					backgroundImage: coverFile ? `url(${coverFile.blobUrl})` : undefined,
				}}
				loop
				autoPlay
				playsInline
				controls={false}
				onEnded={getHandleBlockEvent(props.itemId, ['ended'])}
			>
				{videoFile?.blobUrl && <source src={videoFile.blobUrl} type={isWebm ? "video/webm" : "video/mp4"}></source>}
				{otherFile?.blobUrl && <source src={otherFile.blobUrl}></source>}
				Désolé, votre appareil ne prend pas en charge le format de la vidéo.
			</video>
		</Block>
	);
}